export enum ContentTypes {
  SPORT = 'Sport',
  GENERIC = 'Generic',
  NEWS = 'News',
  OPERATOR = 'Operator',
  TIP = 'Tip'
}
